import React from 'react';
import { motion } from 'framer-motion';

const CyberBackground = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none flex items-center justify-center">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#051d40]/80 via-[#202020] to-[#202020]" />
    <svg className="absolute w-[200%] h-[200%] max-w-none opacity-10" viewBox="0 0 1000 1000" fill="none">
      <ellipse cx="500" cy="500" rx="450" ry="200" stroke="#289199" strokeWidth="1.5" strokeDasharray="4 12" className="animate-[spin_100s_linear_infinite]" />
      <ellipse cx="500" cy="500" rx="350" ry="400" stroke="#f2f2f2" strokeWidth="1" strokeDasharray="2 8" className="animate-[spin_140s_linear_infinite_reverse]" />
      <ellipse cx="500" cy="500" rx="250" ry="250" stroke="#eb5e55" strokeWidth="0.5" strokeDasharray="2 16" opacity="0.4" />
    </svg>
    <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[#202020] to-transparent" />
  </div>
);

export default function Hero({ ctaUrl }) {
  return (
    // Added min-h-full flex flex-col justify-center and py-24
    <section className="relative w-full min-h-full bg-[#202020] flex flex-col items-center justify-center overflow-hidden px-4 sm:px-6 py-24">
      <CyberBackground />
      
      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center gap-5 sm:gap-7">
        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-brand-teal/30 bg-brand-teal/10">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-teal opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-teal" />
          </span>
          <span className="font-lexend text-brand-teal text-[10px] sm:text-xs font-bold uppercase tracking-widest">
            AI Engine — Always On
          </span>
        </motion.div>

        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }} className="font-michroma text-4xl sm:text-5xl md:text-6xl text-white leading-tight tracking-tight">
          Turn Reviews Into <span className="text-brand-teal drop-shadow-[0_0_30px_rgba(40,145,153,0.4)]">Revenue.</span>
          <br />On Autopilot.
        </motion.h1>

        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }} className="font-lexend text-base sm:text-lg text-white/50 max-w-2xl leading-relaxed px-2">
          Three AI agents working 24/7 to dominate local search, amplify your best reviews, and reply before your competitor even wakes up.
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.3 }} className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 w-full sm:w-auto">
          <a href={ctaUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto text-center font-lexend font-bold text-sm uppercase tracking-widest px-8 py-4 rounded-full bg-brand-teal text-white hover:bg-brand-teal/80 transition-all duration-200 shadow-xl shadow-brand-teal/25 hover:-translate-y-0.5">
            Activate Your Engine
          </a>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.5 }} className="w-full pt-6 border-t border-white/5 grid grid-cols-3 gap-4 sm:gap-8">
          {[['3', 'AI Agents'], ['24/7', 'Always Active'], ['∞', 'Compounding']].map(([val, label]) => (
            <div key={label} className="flex flex-col items-center gap-1">
              <span className="font-michroma text-2xl sm:text-3xl md:text-4xl text-white">{val}</span>
              <span className="font-lexend text-[10px] sm:text-xs text-white/40 uppercase tracking-widest">{label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}